import { useMutation } from '@apollo/client';
import clientAccount from 'apps/accounts/app/utils/clientAccount';
import useNotifier from 'hooks/useNotifier';
import { handleGQLErrors } from 'utils/gqlErrors';
import { distributorIncreaseFreeCodeCountForItemMutation } from '../mutations';
import { DistributorIncreaseFreeCodeCountForItem, DistributorIncreaseFreeCodeCountForItemVariables } from '../types/DistributorIncreaseFreeCodeCountForItem';

const useIncreaseFreeCodeCount = ({ onComplete }: { onComplete?: () => void }) => {
  const notify = useNotifier();
  const [mutation, mutationOpts] = useMutation<
    DistributorIncreaseFreeCodeCountForItem,
    DistributorIncreaseFreeCodeCountForItemVariables
  >(distributorIncreaseFreeCodeCountForItemMutation, {
    client: clientAccount,
    onCompleted: (data) => {
      if (onComplete) {
        onComplete();
      }
      notify({ text: 'Updated successfully', status: 'success' });
    },
    onError: (err) => {
      handleGQLErrors(notify, err);
    },
  });

  return {
    mutation,
    mutationOpts,
  };
};

export default useIncreaseFreeCodeCount;
